import { GetterTree, ActionTree, MutationTree } from "vuex";

const state = {
  notifications: [] as Notification[],
};

const getters: GetterTree<typeof state, any> = {
  allNotificationMessages: (state) => state.notifications,
};

let idx = 0;
const actions: ActionTree<typeof state, any> = {
  showNotification({ commit, state }, notification: Notification) {
    // if there is an existing notification with the same ID then clear its timeout and remove it
    const existing = notification.id ? state.notifications.find(e => e.id === notification.id) : null;
    if (existing) {
      if (existing.timeoutId) {
        clearTimeout(existing.timeoutId);
      }
      commit("removeNotification", existing);
    }

    const notificationCopy = { idx: idx++, ...notification };
    if (notificationCopy.timeout) {
      notificationCopy.timeoutId = setTimeout(() => {
        commit("removeNotification", notificationCopy);
      }, notificationCopy.timeout);
    }

    commit("addNotification", notificationCopy);
  },
  closeNotification({ commit }, notification: Notification) {
    commit("removeNotification", notification);
  }
};
const mutations: MutationTree<any> = {
  addNotification: (state, notification) => {
    state.notifications = [...state.notifications, notification];
  },
  removeNotification: (state, notification) => {
    state.notifications = (state.notifications as Notification[]).filter(
      (x) => x != notification
    );
  },
};

export interface Notification {
  id?: number | string;
  idx?: number;
  color: "success" | "info" | "warning" | "error";
  message: string;
  submessages: string[];
  timeout: number;
  localize?: boolean;
  actions?: { text: string; fun: () => boolean }[];
  timeoutId?: number;
}

export default {
  state: () => state,
  getters,
  actions,
  mutations,
};
